import type { VerificationOfPayeeResult } from 'src/core/modules/verification-of-payee/apis';

export const isVerificationOfPayeeResultInvalid = (
  matchingResult: VerificationOfPayeeResult['matchingResult'],
): boolean => matchingResult !== 'match';
